import { Assets } from './Assets'

export const PropertyAssets = ({ assets, handleOnClick }) => {
  const propertyAssets = (assets || []).filter(
    (option) => option.subType === PropertyAssets.targetCategory
  )
  return (
    <Assets
      assets={propertyAssets}
      handleOnClick={handleOnClick}
      category={PropertyAssets.targetCategory}
    />
  )
}
PropertyAssets.targetCategory = 'property'
